import {createSelector} from 'reselect';

// Invoices Stats redux state
const invoicesStatsReducerSelector = state => state.invoicesStats;

// Invoices Stats List
const invoicesStatsSelector = createSelector(
    invoicesStatsReducerSelector,
    invoicesStatsReducer => invoicesStatsReducer.get('payload')
);

// Invoices Stats is fetching
const invoicesStatsIsFetchingSelector = createSelector(
    invoicesStatsReducerSelector,
    invoicesStatsReducer => invoicesStatsReducer.get('isFetching')
);

// Invoices Stats error
const invoicesStatsErrorSelector = createSelector(
    invoicesStatsReducerSelector,
    invoicesStatsReducer => invoicesStatsReducer.get('error')
);

export {
    invoicesStatsSelector,
    invoicesStatsIsFetchingSelector,
    invoicesStatsErrorSelector
};